import { ClaimsEdit } from './components/ClaimsEdit';
import { ClaimsOverview } from './components/ClaimsOverview';
import { ClaimsThresholdYesOrNo } from './components/ClaimsThresholdYesOrNo';
import { PastClaimsProvider, usePastClaimsState } from './usePastClaims';

import type { PastClaimsProviderProps } from './usePastClaims';
import type { RichContentType } from '../../components/RichContent';
import type { CountryCode } from '@insify/global-countries';

export type PastClaimsContent = {
  onBack: () => void;
  isSubmitting?: boolean;
  country: CountryCode | Lowercase<CountryCode>;
  richContent: {
    confirm?: RichContentType;
    overview?: RichContentType;
    form?: RichContentType;
  };
  validation?: {
    minClaimAmount: number;
    maxClaimAmount: number;
  };
  translations: {
    previous: string;
    overviewYes: string;
    overviewNo: string;
    overviewContinue: string;
    overviewEdit: string;
    overviewAddNewButtonCopy: string;
    overviewYearLabel: string;
    overviewCoverageLabel: string;
    overviewAmountLabel: string;
    formSubmit: string;
    formYearLabel: string;
    formYearPlaceholder: string;
    formCoverageLabel: string;
    formCoveragePlaceholder: string;
    formAmountLabel: string;
    validationYearRequired: string;
    validationCoverageRequired: string;
    validationNumberTooLow: string;
    validationNumberTooHigh: string;
    validationAmountRequired: string;
    currency: string;
  };
  currencyPosition: 'before' | 'after';
  thousandSeparator: string;
};

export type PastClaimsProps<CoverageKey extends string> = PastClaimsContent & PastClaimsProviderProps<CoverageKey>;

const ClaimsYesOrNoOrOverview = <CoverageKey extends string>(props: PastClaimsProps<CoverageKey>) => {
  const { pastClaims } = usePastClaimsState();
  return pastClaims.length ? <ClaimsOverview {...props} /> : <ClaimsThresholdYesOrNo {...props} />;
};

export const PastClaims = <CoverageKey extends string>(props: PastClaimsProps<CoverageKey>) => {
  return (
    <PastClaimsProvider {...props}>
      <ClaimsYesOrNoOrOverview {...props} />
      <ClaimsEdit {...props} />
    </PastClaimsProvider>
  );
};
